import serviceTaskRunner, { services, _callRestfulService as restful } from "../lib/restful/services/restAPIs";
import { CryptoTransform } from "../lib/util/ClientUtil";
import { cleanUpTempValues } from "../lib/util/Util";
import sessionData from "../lib/session/sessionData.json"
import { Field, useFormState, useForm } from "react-final-form";
import { SeqCrypto } from "../lib/util/SeqCrypto";
import { useUserSession } from '../lib/session/UserSession';
import {
  getUrlImageType,
  resizeImageDataString,
  base64ToFile,
  reduceImageResolution,
  reduceImageResolutionByHeight
} from "../utils/common";
import { v4 as uuid } from "uuid";

import { ClientMediator } from '@8d-xyz/ui-react_application_f-container';
import VaultLib from '../lib/util/Vault'; // adjust path as needed





async function _contextEncrypt(values) {
  let contextEncrypt = null;
  if (values.password!=null && values.password!=="" ) {
    let keys = [];
    !!values.secureKey ? keys.push(values.secureKey) : "";
    !!values.challenge && !!values.useChallenge ? keys.push(values.challenge) : "";
    contextEncrypt = await CryptoTransform.SIMPLE_ENCRYPT(values.password, keys);
    values.password = contextEncrypt.ciphertext;
  }
  return contextEncrypt;
}



async function _vaultCreateAndEncrypt(values) {
 if (!!!values?.vault?.encryptedVaultKey && !!!values?.vault?.staging?.vaultPassword ) {
  delete values?.vault?.staging;
   // no vault is to be created
  return;
 }

 //in vault staging data or boolean vaultPasswordChangeRequest value set at all
 if (!values.vault.staging || values.vault.staging.vaultPasswordChangeRequest==undefined) {
  //no operation on vault
  return;
 }

  let salt = null;
  let passwordKey = null;
  let vaultKey = null;
  let encryptedVaultKeyx = null;
  let vaultKeyIv = null;
  let hint = null;


 if(values.vault.staging.vaultPasswordChangeRequest  //yes a request is made
  && values.vault.staging.vaultChangePassword!=null   //yes there is a vault password set 
  && values.vault.staging.vaultChangePassword === values.vault.staging.vaultChangePasswordConfirm  //yes the password is check the same
     ){
 
  salt = crypto.getRandomValues(new Uint8Array(16));
  passwordKey = await VaultLib.getMasterPassword(values.vault.staging.vaultChangePassword, [
    values.id,
    sessionData.USER_PROFILE.uid,
  ], salt);
  vaultKey = await VaultLib.generateVaultKey();
  let { encryptedVaultKey, iv } = await VaultLib.encryptVaultKey(vaultKey,passwordKey);
  encryptedVaultKeyx=encryptedVaultKey;
  vaultKeyIv=iv;
  hint = values.vault.staging.vaultChangePasswordHint


 }else{
  salt = values.vault.salt;
  passwordKey = await VaultLib.getMasterPassword(values.vault.staging.vaultPassword, [
    values.id,
    sessionData.USER_PROFILE.uid,
  ], salt);

  encryptedVaultKeyx = values.vault.encryptedVaultKey;
  vaultKeyIv = values.vault.vaultKeyIv;

  vaultKey =  await VaultLib.decryptVaultKey(
    values.vault.encryptedVaultKey,
    passwordKey,
    values.vault.vaultKeyIv
  );

  hint = values.vault.hint;
 }
  
  let content = await VaultLib.encryptVaultData(vaultKey,values.vault.staging.vaultEntries );
  let checksum = await VaultLib.encryptVaultData(vaultKey, values.id );
  //wipe clean all staging information
  values.vault={
    hint: hint,
    vaultKeyIv: vaultKeyIv,
    salt: salt,
    encryptedVaultKey:encryptedVaultKeyx,
    content: content,
    checksum: checksum
  }


}

export const SAVE_ENTITY_IMAGE = async (type, values, callBack) => {
  cleanUpTempValues(values);
  let urlImageType = await getUrlImageType({ urlImage: values.urlImage });
  if (urlImageType != "invalid" && urlImageType.startsWith("url")) {
    //loaded from backend
    //no need to do anything
  } else if (urlImageType != "invalid" && urlImageType.startsWith("dataString")) {

    let fileName = type + "_" + values.id;
    let file = base64ToFile(await reduceImageResolution(values.urlImage, 600), fileName)
    const formData = new FormData();
    formData.append('files', file);
    let result = await serviceTaskRunner(services.UPLOAD_FILES)(
      formData, { 'content-type': "multipart/form-data" },
      async (response, callParams) => {
        const data = response.data.payload;
        //console.log("imageUrl");
        //console.log(data[0].url);
        callParams.handleSubmit(data[0].url);

        let result = null;
        return data;
      },
      {
        //callBack Parameters
        handleSubmit: callBack
      },
      (error) => {
        //console.log(error)
      }
    );

  }
}
//values, dialogClosing, callBack
export const CREATE_ENTITY = async (type, values, dialogClosing, callBack) => {
  cleanUpTempValues(values);
  //if id is available -> update
  //check urlImage if it is url reference or B64 data
  //if url reference image already uploaded
  //if url B64 image needs to be updated: make two calls

  values.id = !values.id ? uuid() : values.id;
  //let urlImageType = await getUrlImageType({urlImage:image});
  let urlImageType = await getUrlImageType({ urlImage: values.urlImage });
  if (urlImageType != "invalid" && urlImageType.startsWith("url")) {
    //loaded from backend
    //no need to do anything
  } else if (urlImageType != "invalid" && urlImageType.startsWith("dataString")) {
    // needs to upload and replace if needed to
    //if(values.id) exists means replace the image with same urle file name in the if urlImage in db is not blank
    //if(values.id) does not exist means new record create a new entry and get the record id back and use it to further processing
   
    let fileName = type + "_" + values.id;

    //console.log(fileName)
    // let fileName = values.id;
    let file = base64ToFile(await reduceImageResolution(values.urlImage, 600), fileName)
    const formData = new FormData();
    formData.append('files', file);
    let result = await serviceTaskRunner(services.UPLOAD_FILES)(
      formData, { 'content-type': "multipart/form-data" },
      async (response, callParams) => {
        //callBack function
        //Get return data from the restufl call
        const data = response.data.payload;
        //console.log("data[0][0].url");

        values.urlImage = data[0].url;
        let result = null;
        //do something
        return data;
      },
      {
        //callBack Parameters
      },
      (error) => {
        //console.log(error)
      }
    );

  }

  //all updated
  await _vaultCreateAndEncrypt(values)
  let contextEncrypt = await _contextEncrypt(values);

  let dataz = await CryptoTransform.TO_BASE64(
    values,
    process.env.APP_ID,
    sessionData.USER_PROFILE.uid);

  if (!!contextEncrypt && contextEncrypt.ivs.length > 0) {
    //last two is the ivs generated from the oringial source data  and the first two ivs is from  process.env.APP_ID,sessionData.USER_PROFILE.uid
    dataz.ivs = [...dataz.ivs, ...contextEncrypt.ivs];    //add the ivs for client info (securekey and challenge)
  }

  await serviceTaskRunner(services.ADD_ENTITY)(
    type,
    dataz,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      let result = response.data.payload;
      //console.log(result);
      callParams.handleSubmit(result);
      //do something fire event for dialog etc...
      // alert("fire create")
      ClientMediator.broadcastEvent({
        "event_id": `APP-ENTITY_CHANGED`, //EVENT KEY (publihserId+event)
        "payload": {
          "ENTITY": type,
          "ID": result.id,
          "ACTION": "CREATED"
        }
      });
      return result;
    },
    {
      handleSubmit: callBack
    },
    (error) => {
      //console.log(error)
    }
  );

  dialogClosing();
}

export const DELETE_ENTITY = async (entity, callback) => {

  serviceTaskRunner(services.DELETE_ENTITY)(entity.parent.toUpperCase(),
    entity.id, {},
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = null;
      //do something
      ClientMediator.broadcastEvent({
        "event_id": `APP-ENTITY_CHANGED`, //EVENT KEY (publihserId+event)
        "payload": {
          "ENTITY": data.type,
          "ID": data.id,
          "ACTION": "DELETED"
        }
      });
      return data;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error)
    }
  );

  callback();
}


export const GET_ORGANIZERS = async (values, callback) => {
  cleanUpTempValues(values);
  return await serviceTaskRunner(services.GET_ORGANIZERS)(
    values,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error)
    }
  );


}

export const GET_ENTITY_MEDIA = async (entity_group, file_id, callback) => {

  return serviceTaskRunner(services.GET_ENTITY_MEDIA)(
    entity_group, file_id, {},
    async (response, callParams) => {
      return await callback(response);
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error);
    }
  );
}


export const GET_ORGANIZER_BY_TYPE = async (type, values, callback) => {
  cleanUpTempValues(values);
  return await serviceTaskRunner(services.GET_ORGANIZER)(type,
    values,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error)
    }
  );


}

export const SYNC_ENTITY_LIST_ORDER = async (type, from, to, values, callback) => {
  cleanUpTempValues(values);
  return await serviceTaskRunner(services.SYNC_ENTITY_LIST_ORDER)(
    type, from, to, values,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error)
    }
  );

}
export const GET_ENTITY_RECORD = async (type, id, filter, values, callback) => {
  cleanUpTempValues(values);
  return await serviceTaskRunner(services.GET_ENTITY)(
    type, id, filter, values,
    async (response, callParams) => {

      let result = await CryptoTransform.TO_UTF8(response.data.payload, process.env.APP_ID,
        sessionData.USER_PROFILE.uid);
      return result;
    },
    {
      //callBack Parameters
    },
    () => { }
  );

}
export const UPDATE_ENTITY_RECORD = async (type, values, dialogClosing, callBack) => {
  cleanUpTempValues(values);
  //if id is available -> update
  //check urlImage if it is url reference or B64 data
  //if url reference image already uploaded
  //if url B64 image needs to be updated: make two calls
  let urlImageType = await getUrlImageType(values);
  //alert(urlImageType);

  if (urlImageType != "invalid" && urlImageType.startsWith("url")) {
    //loaded from backend
    //no need to do anything
  } else if (urlImageType != "invalid" && urlImageType.startsWith("dataString")) {
    // needs to upload and replace if needed to
    //if(values.id) exists means replace the image with same urle file name in the if urlImage in db is not blank
    //if(values.id) does not exist means new record create a new entry and get the record id back and use it to further processing
    // values.urlImage = await Promise.all([resizeImageDataString(values.urlImage, 300,300)])[0];
    //values.id = uuid();
    //values.id ="b307e824-0817-4db9-a993-de8d4a285733"

    let fileName = type + "_" + values.id;

    let file = base64ToFile(await reduceImageResolution(values.urlImage, 600), fileName)
    const formData = new FormData();
    formData.append('files', file);
    let result = await serviceTaskRunner(services.UPLOAD_FILES)(
      formData, { 'content-type': "multipart/form-data" },
      async (response, callParams) => {
        //callBack function
        //Get return data from the restufl call
        const data = response.data.payload;
        //console.log("data[0][0].url");

        values.urlImage = data[0].url;


        let result = null;
        //do something
        return data;
      },
      {
        //callBack Parameters
      },
      (error) => {
       // console.log(error)
      }
    );
  }

  let contextEncrypt = await _contextEncrypt(values);
  
  await _vaultCreateAndEncrypt(values)
  let dataz = await CryptoTransform.TO_BASE64(
    values,
    process.env.APP_ID,
    sessionData.USER_PROFILE.uid);

  if (!!contextEncrypt && contextEncrypt.ivs.length > 0) {
    dataz.ivs = [...dataz.ivs, ...contextEncrypt.ivs]    //add the ivs for client info (securekey and challenge)
  }else{
    dataz.ivs=null;
  }
  //ivs is safe guraded by server immutable when non change of passowrd
  await serviceTaskRunner(services.UPDATE_ENTITY)(
    type, values.id, dataz,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      let result = response.data.payload;
      callParams.handleSubmit(result);
      ClientMediator.broadcastEvent({
        "event_id": `APP-ENTITY_CHANGED`, //EVENT KEY (publihserId+event)
        "payload": {
          "ENTITY": type,
          "ID": result.id,
          "ACTION": "UPDATED"
        }
      });
      //do something fire event for dialog etc...
      return result;
    },
    {
      //callBack Parameters
      handleSubmit: callBack
    },
    (error) => {
      //console.log(error)
    }
  );
  dialogClosing();
}



export const CLONE_ENTITY_RECORD = async (type, id, values, callback) => {
  cleanUpTempValues(values);
  serviceTaskRunner(services.COPY_ENTITY)(
    type, id, values,
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      let result = response.data.payload;
      //console.log(result);
      callParams.handleSubmit(result);
      //alert("fire clone")
      ClientMediator.broadcastEvent({
        "event_id": `APP-ENTITY_CHANGED`, //EVENT KEY (publihserId+event)
        "payload": {
          "ENTITY": "PASSWROD",
          "ID": result.id,
          "ACTION": "CLONED"
        }
      });
      //do something
      return result;
    },
    {
      handleSubmit: callback
    },
    (error) => {
      console.error(error)
    }
  );



}
